var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5714 8.76186H8.76186V12.5714C8.76186 12.9904 8.41901 13.3333 7.99996 13.3333C7.58091 13.3333 7.23805 12.9904 7.23805 12.5714V8.76186H3.42853C3.00948 8.76186 2.66663 8.41901 2.66663 7.99996C2.66663 7.58091 3.00948 7.23805 3.42853 7.23805H7.23805V3.42853C7.23805 3.00948 7.58091 2.66663 7.99996 2.66663C8.41901 2.66663 8.76186 3.00948 8.76186 3.42853V7.23805H12.5714C12.9904 7.23805 13.3333 7.58091 13.3333 7.99996C13.3333 8.41901 12.9904 8.76186 12.5714 8.76186Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.cfe10e7b.svg";
export { ForwardRef as ReactComponent };